import React, { useEffect } from 'react'
import Table from 'duties/business_rules/Table'

function BusinessRulesTable({ processId, selectedDepartment, selectedApprovalTypes, amount }) {
  const [params, setParams] = React.useState({
    page: 1,
    perPage: 25,
    process_type_id: processId
  })

  // Update params when filters change
  useEffect(() => {
    setParams((prev) => {
      const newParams = {
        ...prev,
        page: 1
      }

      // Apply department filter
      if (selectedDepartment) {
        newParams.department_code = selectedDepartment
      } else {
        delete newParams.department_code
      }

      // Apply approval types filter
      if (selectedApprovalTypes && selectedApprovalTypes.length > 0) {
        newParams.approval_types = selectedApprovalTypes
      } else {
        delete newParams.approval_types
      }

      // Apply amount filter
      if (amount !== '' && amount !== undefined) {
        newParams.amount = amount
      } else {
        delete newParams.amount
      }

      return newParams
    })
  }, [selectedDepartment, selectedApprovalTypes, amount])

  return <Table params={params} setParams={setParams} />
}

export default BusinessRulesTable
